module.exports = __webpack_public_path__ + "static/media/notecut.5989178e.png";